<template>
  <div class="fixed bottom-0 w-full bg-white border-solid  border-t border-gray-100">
    <div class="w-full flex max-w-screen-2xl mx-auto">
    <inertia-link :href="route('dashboard')" class="w-3/12 px-2 py-3">
      <img src="/img/icon-home.svg" alt="home" class="h-7 m-auto">
    </inertia-link>
    <inertia-link :href="route('curricula')" class="w-3/12 px-2 py-3 relative">
      <img src="/img/bar-chart.svg" alt="programmi" class="h-7 m-auto">
    </inertia-link>
    <inertia-link :href="route('users.profile')" class="w-3/12 px-2 py-3">
      <div class="relative mx-auto" style="max-width:30px;">
        <img src="/img/icon-diamond.svg" alt="profilo" class="h-7 m-auto">
        <span v-if="diamonds != null" class="absolute top-0 -right-1 rounded-full w-5 h-5 bg-green-500 text-white text-center text-xs  font-bold" style="padding-top:0.15rem;">{{ diamonds }}</span>
      </div>
    </inertia-link>
    <inertia-link href="/user/profile" class="w-3/12 px-2 py-3">
      <img src="/img/icon-user.svg" alt="impostazioni" class="h-7 m-auto">
    </inertia-link>
     </div>
  </div>
</template>

<script>
export default {
  props: ['diamonds']
}                                                                                                     
</script>
